import { all, fork } from 'redux-saga/effects';
import { daccaInitialState, daccaReducer } from './dacca/reducer';
import { detailsAgendaInitialState, detailsAgendaReducer } from './agenda/reducer';
import { detailsCaseInitialState, detailsCaseReducer } from './case/reducer';
import { detailsCommentOrReportInitialState, detailsCommentOrReportReducer } from './comment-or-report/reducer';
import { detailsExpertiseAttachmentInitialState, detailsExpertiseAttachmentReducer } from './expertise-attachment/reducer';
import { detailsImagesInitialState, detailsImagesReducer } from './images/reducer';
import { detailsInsuredPersonInitialState, detailsInsuredPersonReducer } from './insured-person/reducer';
import { detailsOtherAttachmentsInitialState, detailsOtherAttachmentsReducer } from './other-attachments/reducer';
import { detailsPolicyInitialState, detailsPolicyReducer } from './policy/reducer';
import { detailsRimInitialState, detailsRimReducer } from './rim/reducer';
import { detailsSharedInitialState, detailsSharedReducer } from './shared/reducer';
import { detailsSvsInitialState, detailsSvsReducer } from './svs/reducer';
import { overviewInitialState, overviewReducer } from './overview/reducer';

import { DaccaState } from './dacca/types';
import { DetailsAgendaState } from './agenda/types';
import { DetailsCaseState } from './case/types';
import { DetailsCommentOrReportState } from './comment-or-report/types';
import { DetailsExpertiseAttachmentState } from './expertise-attachment/types';
import { DetailsImagesState } from './images/types';
import { DetailsInsuredPersonState } from './insured-person/types';
import { DetailsOtherAttachmentsState } from './other-attachments/types';
import { DetailsPolicyState } from './policy/types';
import { DetailsRimState } from './rim/types';
import { DetailsSharedState } from './shared/types';
import { DetailsSvsState } from './svs/types';
import { OverviewState } from './overview/types';
import { combineReducers } from 'redux';
import communicationOverviewSaga from './overview/sagas';
import daccaSaga from './dacca/sagas';
import detailsAgendaSaga from './agenda/sagas';
import detailsCaseSaga from './case/sagas';
import detailsCommentOrReportSaga from './comment-or-report/sagas';
import detailsExpertiseAttachmentSaga from './expertise-attachment/sagas';
import detailsImagesSaga from './images/sagas';
import detailsInsuredPersonSaga from './insured-person/sagas';
import detailsOtherAttachmentsSaga from './other-attachments/sagas';
import detailsPolicySaga from './policy/sagas';
import detailsRimSaga from './rim/sagas';
import detailsSharedSaga from './shared/sagas';
import svsSaga from './svs/sagas';
import { DetailsHonoraryNoteState } from './honorary-note/types';
import { detailsHonoraryNoteInitialState, detailsHonoraryNoteReducer } from './honorary-note/reducer';
import detailsHonoraryNoteSaga from './honorary-note/sagas';

export interface DetailsState {
  detailsShared: DetailsSharedState;
  detailsCase: DetailsCaseState;
  detailsPolicy: DetailsPolicyState;
  detailsInsuredPerson: DetailsInsuredPersonState;
  detailsExpertiseAttachment: DetailsExpertiseAttachmentState;
  detailsRim: DetailsRimState;
  detailsImages: DetailsImagesState;
  detailsOtherAttachments: DetailsOtherAttachmentsState;
  detailsSvs: DetailsSvsState;
  detailsAgenda: DetailsAgendaState;
  detailsDacca: DaccaState;
  detailsCommentOrReport: DetailsCommentOrReportState;
  detailsOverview: OverviewState;
  detailsHonoraryNote: DetailsHonoraryNoteState;
}

export const detailsInitialState: DetailsState = {
  detailsShared: detailsSharedInitialState,
  detailsCase: detailsCaseInitialState,
  detailsPolicy: detailsPolicyInitialState,
  detailsInsuredPerson: detailsInsuredPersonInitialState,
  detailsExpertiseAttachment: detailsExpertiseAttachmentInitialState,
  detailsRim: detailsRimInitialState,
  detailsImages: detailsImagesInitialState,
  detailsOtherAttachments: detailsOtherAttachmentsInitialState,
  detailsSvs: detailsSvsInitialState,
  detailsAgenda: detailsAgendaInitialState,
  detailsDacca: daccaInitialState,
  detailsCommentOrReport: detailsCommentOrReportInitialState,
  detailsOverview: overviewInitialState,
  detailsHonoraryNote: detailsHonoraryNoteInitialState
};

export const detailsReducer = combineReducers({
  detailsCase: detailsCaseReducer,
  detailsShared: detailsSharedReducer,
  detailsInsuredPerson: detailsInsuredPersonReducer,
  detailsPolicy: detailsPolicyReducer,
  detailsExpertiseAttachment: detailsExpertiseAttachmentReducer,
  detailsRim: detailsRimReducer,
  detailsImages: detailsImagesReducer,
  detailsOtherAttachments: detailsOtherAttachmentsReducer,
  detailsSvs: detailsSvsReducer,
  detailsAgenda: detailsAgendaReducer,
  detailsDacca: daccaReducer,
  detailsCommentOrReport: detailsCommentOrReportReducer,
  detailsOverview: overviewReducer,
  detailsHonoraryNote: detailsHonoraryNoteReducer
});

export function* detailsSaga() {
  yield all([
    fork(detailsCaseSaga),
    fork(detailsInsuredPersonSaga),
    fork(detailsPolicySaga),
    fork(detailsExpertiseAttachmentSaga),
    fork(detailsImagesSaga),
    fork(detailsRimSaga),
    fork(detailsOtherAttachmentsSaga),
    fork(svsSaga),
    fork(detailsAgendaSaga),
    fork(daccaSaga),
    fork(detailsSharedSaga),
    fork(detailsCommentOrReportSaga),
    fork(communicationOverviewSaga),
    fork(detailsHonoraryNoteSaga)
  ]);
}
